import { axiosPost } from '../ServiceBase';

export const getCuposPractica = async ({
  idAfiliado = null,
  practicas = [],
  fechaInicio = null,
}) => {
  const response = await axiosPost(`/v1/afiliados/${idAfiliado}/practicas/cupos`, {
    practicas,
    fechaInicio,
  });
  return response;
};
